import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledManageDealerAvailabilityTitleContainer: any = styled.div`
  font-size: ${(theme: VWTheme) => theme?.size?.static250 || '20px'};
  font-weight: 700;


  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '24px'};
  }
`;

export const StyledManageDealerAvailabilityContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};
  padding: 0 1px;
  width: 100%;

  select {
    @media (min-width: ${Breakpoints.b1600}px) {
      font-size: ${(theme: VWTheme) => theme?.size?.static200 || '20px'};
    }
  }

  @media (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledAvailabilityInfoContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(theme: VWTheme) => theme?.size?.static100 || '8px'};
  width: 100%;
`;

export const StyledDayScheduleItem: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  font-size: ${(theme: VWTheme) => theme?.size?.static150 || '16px'};

  @media (min-width: 375px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '20px'};
  }
`;

export const StyledDayLabel: any = styled.span`
  font-weight: 400;
  color: ${(theme: VWTheme) => theme?.colors?.content?.tertiary || '#3C484D'};
  text-transform: capitalize;
  line-height: ${(theme: VWTheme) => theme?.size?.static200 || '24px'};

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '20px'};
  }
`;

export const StyledTimeLabel: any = styled.span`
  font-weight: 400;
  color: ${(theme: VWTheme) => theme?.colors?.content?.secondary || '#6A767D'};

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '20px'};
  }
`;

export const StyledClosedLabel: any = styled.span`
  font-weight: 400;
  color: ${(theme: VWTheme) => theme?.colors?.content?.secondary || '#6A767D'};

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '20px'};
  }
`;

export const StyledManageDealerAvailabilityContentContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};

  @media (min-width: ${Breakpoints.b960}px) {
    width: 560px;
  }
`;
